import { useSelector } from 'react-redux'
import { MODAL_TYPES } from '../../common/constants'
import { selectModalProps, selectModalStack } from '../../store/modal'
import ActivityModal from './ActivityModal/ActivityModal'
import AgentPrintModal from './AgentPrintModal/AgentPrintModal'
import ChangeAgentModal from './ChangeAgentModal/ChangeAgentModal'
import CloneModal from './CloneModal'
import DeleteModal from './DeleteModal/DeleteModal'
import ExportAdsModal from './ExportAdsModal/ExportAdsModal'
import ExportDataModal from './ExportDataModal/ExportDataModal'
import ExportSyncModal from './ExportSyncModal'
import FormValidationErrorModal from './FormValidationErrorModal/FormValidationErrorModal'
import NotesModal from './NotesModal/NotesModal'
import OfferBaseModal from './OfferModals/modals/OfferBaseModal'
import OfferPreviewModal from './OfferModals/modals/OfferPreviewModal'
import OfferSendModal from './OfferModals/modals/OfferSendModal'
import OfferSettingsModal from './OfferModals/modals/OfferSettingsModal'
import PropertyPrintFormModal from './PropertyPrintFormModal/PropertyPrintFormModal'
import QuickViewModal from './QuickViewModal/QuickViewModal'
import ReadAllModal from './ReadAllModal'
import ReturnToOfferModal from './ReturnToOfferModal/ReturnToOfferModal'
import ShopWindowPrintModal from './ShopWindowPrint/ShopWindowPrintModal/ShopWindowPrintModal'
import TemplateModal from './ShopWindowPrint/TemplatesModal/TemplatesModal'

const MODAL_COMPONENTS = {
    [MODAL_TYPES.ACTIVITY_MODAL]: ActivityModal,
    [MODAL_TYPES.AGENT_PRINT_MODAL]: AgentPrintModal,
    [MODAL_TYPES.CHANGE_AGENT_MODAL]: ChangeAgentModal,
    [MODAL_TYPES.CLONE_MODAL]: CloneModal,
    [MODAL_TYPES.DELETE_MODAL]: DeleteModal,
    [MODAL_TYPES.EXPORT_ADS_MODAL]: ExportAdsModal,
    [MODAL_TYPES.EXPORT_DATA_MODAL]: ExportDataModal,
    [MODAL_TYPES.EXPORT_SYNC_MODAL]: ExportSyncModal,
    [MODAL_TYPES.FORM_VALIDATION_ERROR_MODAL]: FormValidationErrorModal,
    [MODAL_TYPES.NOTES_MODAL]: NotesModal,
    [MODAL_TYPES.OFFER_BASE_MODAL]: OfferBaseModal,
    [MODAL_TYPES.OFFER_PREVIEW_MODAL]: OfferPreviewModal,
    [MODAL_TYPES.OFFER_SEND_MODAL]: OfferSendModal,
    [MODAL_TYPES.OFFER_SETTINGS_MODAL]: OfferSettingsModal,
    [MODAL_TYPES.PROPERTY_PRINT_FORM_MODAL]: PropertyPrintFormModal,
    [MODAL_TYPES.QUICK_VIEW_MODAL]: QuickViewModal,
    [MODAL_TYPES.READ_ALL_MODAL]: ReadAllModal,
    [MODAL_TYPES.RETURN_TO_OFFER_MODAL]: ReturnToOfferModal,
    [MODAL_TYPES.SHOPWINDOW_PRINT_MODAL]: ShopWindowPrintModal,
    [MODAL_TYPES.TEMPLATES_MODAL]: TemplateModal,
}

const ModalRoot = () => {
    const { modalStack, modalProps } = useSelector((state) => ({
        modalStack: selectModalStack(state),
        modalProps: selectModalProps(state),
    }))

    if (modalStack.length === 0) {
        return null
    }

    // last modal in stack is visible
    const activeModalType = modalStack.at(-1)

    return (
        <>
            {modalStack.map((modalType) => {
                const ModalComponent = MODAL_COMPONENTS[modalType]
                const isOpen = modalType === activeModalType

                return <ModalComponent key={modalType} {...modalProps} isOpen={isOpen} />
            })}
        </>
    )
}

export default ModalRoot
